// startup
// Load entry module and return exports
__webpack_require__("./Content/Scripts/app.ts");
// This entry module doesn't tell about it's top-level declarations so it can't be inlined
__webpack_require__("./Content/Styles/main.scss");
__webpack_require__("./Content/Styles/geopier.scss");
var __webpack_exports__ = __webpack_require__("./Content/Scripts/js/dom-fader.js");
